import { render, staticRenderFns } from "./PlayerHeader.vue?vue&type=template&id=23f80ac6&scoped=true&"
import script from "./PlayerHeader.vue?vue&type=script&lang=js&"
export * from "./PlayerHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlayerHeader.vue?vue&type=style&index=0&id=23f80ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f80ac6",
  null
  
)

export default component.exports